import { PowerUnits, TimeUnits } from './KPIWidget.types';

export const convertPower = (value: number, fromUnit: PowerUnits): { value: number; unit: PowerUnits } => {
  switch (fromUnit) {
    case PowerUnits.WH:
      if (value >= 1000000) {
        return { value: parseFloat((value / 1000000)?.toFixed(2)), unit: PowerUnits.MWH };
      } else if (value >= 1000) {
        return { value: parseFloat((value / 1000)?.toFixed(2)), unit: PowerUnits.KWH };
      }
      break;

    case PowerUnits.KWH:
      if (value >= 1000) {
        return { value: parseFloat((value / 1000)?.toFixed(2)), unit: PowerUnits.MWH };
      } else if (value < 1) {
        return { value: parseFloat((value * 1000)?.toFixed(2)), unit: PowerUnits.WH };
      }
      break;
  }

  return { value: parseFloat(value?.toFixed(2)), unit: fromUnit };
};
export const convertTime = (value: number, fromUnit: TimeUnits): Record<TimeUnits, number> => {
  const timeConversion = {
    [TimeUnits.Y]: 31536000, // Approximate value for 1 year
    [TimeUnits.MO]: 2628000, // Approximate value for 1 month
    [TimeUnits.W]: 604800,
    [TimeUnits.D]: 86400,
    [TimeUnits.H]: 3600,
    [TimeUnits.MIN]: 60,
    [TimeUnits.S]: 1,
  };

  const result: Record<TimeUnits, number> = {
    [TimeUnits.Y]: 0,
    [TimeUnits.MO]: 0,
    [TimeUnits.W]: 0,
    [TimeUnits.D]: 0,
    [TimeUnits.H]: 0,
    [TimeUnits.MIN]: 0,
    [TimeUnits.S]: 0,
  };

  //Convert value to seconds
  let remainingValue = value * timeConversion[fromUnit];
  for (const unit of Object.values(TimeUnits)) {
    if (remainingValue >= timeConversion[unit]) {
      result[unit] = Math.floor(remainingValue / timeConversion[unit]);
      remainingValue -= result[unit] * timeConversion[unit];
    }
  }

  return result;
};

export const formatTimeString = (timeObject: Record<TimeUnits, number>): string => {
  const formattedTimeParts: string[] = [];

  let unitCount = 0;

  for (const unit of Object.values(TimeUnits)) {
    if (timeObject[unit] > 0 && unitCount < 2) {
      formattedTimeParts.push(`${timeObject[unit as keyof typeof timeObject]}${unit}`);
      unitCount++;
    }
  }

  return formattedTimeParts.join(':');
};
